import Vue from "vue";
import util from '../../utils/util'

const state = {
    sceneId: "",
    presetQuestion: [], // 初次进入时的与提问问题
    initStatus: false, // 初始化状态，为true时才能发送下洗
    accessToken: "",
    imUserID: "", // im通道 用户 id
    refreshToken: "",
    customerId: "",
    customerName: "",
    device_uid: "", // 设备 uid
    device_customername: "", // 设备  用户名
    device_devicetype: "", // 设备  设备类型 ios  android pc
    vipLevel: '',
    device_deviceid: "1", // 设备 id
    device_uniqueId: '',
    device: "",
    channelId: "", // 频道id   聊天用
    staffId: "", //
    customerState: 0, //  用户状态   0： 机器人    1：排队中    2：客服正在接待，无需处理    3: 场景模式
    msgList: [], // 消息列表
    msgHistoryList: [], // 历史消息列表
    blurryQuestions: [], // 点击理解错误提示问题
    feedbackObj: '',
    calling: 0, // 接人工标志位  0: 未接人工   1：预转接（不多次发送转接请求）    2：正在排队   3：已经接通
    similarObj: { // 相似问题对象
        key: [],
        list: []
    },
    imagesList: {
        "./static/img/errorimg.png": {
            width: 80,
            height: 80
        }
    },
    historyEmpty: false
}

const getters = {
    calling: state => state.calling,
    feedbackObj: state => state.feedbackObj,
    similarObj: state => state.similarObj,
    initStatus: state => state.initStatus,
    channelId: state => state.channelId,
    customerId: state => state.customerId,
    imUserID: state => state.imUserID,
    msgList: state => state.msgList,
    msgHistoryList: state => state.msgHistoryList,
    customerState: state => state.customerState,
    presetQuestion: state => state.presetQuestion,
    historyEmpty: state => state.historyEmpty,
    staffId: state => state.staffId,
    blurryQuestions: state => state.blurryQuestions,
    qaUserOptParams: state => {
        return {
            eid: state.device_deviceid,
            uid: state.customerId,
            sessionId: state.imUserID,
            sceneid: state.sceneId,
            ip: '127.0.0.1'
        }
    },
    sendMessageParams: state => {
        return {
            device: state.device_devicetype,
            deviceId: state.device_deviceid,
            customerId: state.customerId,
            channelId: state.channelId,
            customerName: state.customerName
        }
    },
    robotFeedbackParams: state => {
        return {
            DeviceId: state.device_deviceid,
            SceneId: state.sceneId,
            CustomerId: state.customerId,
            SessionId: state.imUserID,
            ChannelId: state.channelId
        }
    },
    feedbackParams: state => {
        return {
            DeviceId: state.device_deviceid,
            SceneId: state.sceneId,
            CustomerId: state.customerId,
            SessionId: state.imUserID,
            FeedbackType: 2,
            ChannelId: state.channelId
        }
    },
    presetQuestionParam: state => {
        return {
            CustomerId: state.device_uid,
            CustomerName: !!state.device_uid ? state.device_customerName : '',
            Device: state.device_devicetype,
            DeviceId: state.device_deviceid,
            SceneId: state.sceneId
        }
    },
    getSimilarQuestionParam: state => {
        return {
            DeviceId: state.device_deviceid,
            CustomerId: state.customerId,
            SessionId: state.imUserID,
            SceneId: state.sceneId
        }
    },
    askRobotParams: state => {
        return {
            CustomerId: state.customerId,
            CustomerName: state.customerName,
            Device: state.device_devicetype,
            SessionId: state.imUserID,
            DeviceId: state.device_deviceid,
            SceneId: state.sceneId
        }
    },
    getClientHistoryMessagesParams: state => {
        return {
            deviceId: state.device_deviceid,
            customerId: state.customerId,
            currentchannelId: state.channelId || ""
        }
    },
    imConfig: state => {
        return {
            accessToken: state.accessToken,
            imUserID: state.imUserID,
            refreshToken: state.refreshToken
        }
    },
    fundChatInfo: state => {
        return {
            customerId: state.customerId,
            customerName: state.customerName
        }
    },
    authParams: state => {
        return {
            NickName: "",
            IMUserID: state.imUserID,
            AppKey: configs.AppKey,
            AppSecret: configs.AppSecret,
            Version: "1",
            Device: state.device_devicetype,
        }
    },
    loginByIMToken: state => {
        return {
            imUserID: state.imUserID,
            accessToken: state.accessToken,
            device: state.device_devicetype,
            Version: state.Version,
            refreshToken: state.refreshToken
        }
    },
    applyLineupParams: state => {
        return {
            urlReferer: document.referrer, // returnUrl
            customerId: state.customerId,
            customerName: state.customerName,
            device: state.device_devicetype,
            deviceId: state.device_deviceid,
            uniqueId: state.device_uniqueId
        }
    },
}

const actions = {

}

const mutations = {

    m_scene_id(state, id) {
      state.sceneId = id;
    },

    m_preset_question(state, payload) {
        state.presetQuestion = payload || [];
    },

    m_customer_info(state, payload) {
        state.customerId = payload.customerId;
        state.customerName = payload.customerName;
    },

    m_fund_info(state, data) {
        state.customerId = data.CustomerId;
        state.customerName = data.CustomerName;
        state.channelId = data.ChannelId;
        state.customerState = data.CustomerState;
        state.staffId = data.StaffId;
        state.imUserID = data.IMUserId;
    },

    m_device_info(state, data) {
        state.device_uid = data.uid || "";
        state.device_customerName = data.customername || "";
        state.device_devicetype = !!data.devicetype ? data.devicetype.toLowerCase() : "";
        state.device_deviceid = data.deviceid || util.getGuid();
        state.device_uniqueId = data.uniqueId || '';
    },

    m_auth_user(state, data) {
        state.accessToken = data.Token;
        state.imUserID = data.IMUserID;
        state.refreshToken = data.RefreshToken;
    },

    m_accessToken(state, accessToken) {
        state.accessToken = accessToken;
    },

    m_customer_state(state, customerState) {
        state.customerState = customerState;
    },

    m_channel_id(state, channelId) {
        state.channelId = channelId
    },

    m_msg_list(state, msgs) {
        state.msgList.push(msgs)
    },

    m_msg_history(state, msg) {
        if (Array.isArray(msg)) {
            state.msgHistoryList.unshift(...msg);
        } else {
            state.msgHistoryList.unshift(msg);
        }
    },

    m_history_empty(state, type) {
        state.historyEmpty = type
    },

    m_msg_status(state, payload) {
        var list = state.msgList;
        var len = list.length;
        for (var i = len - 1; i >= 0; i--) {
            if (list[i].msgid === payload.msgid) {
                Vue.set(state.msgList[i], "msgStatus", payload.msgStatus)
                break
            }
        }
    },

    m_robot_say(state, payload) {
        var list = state.msgList;
        var len = list.length;
        for (var i = len - 1; i >= 0; i--) {
            if (list[i].id === payload.id) {
                for (var o in payload) {
                    if (o == "msgid") continue;
                    Vue.set(list[i], o, payload[o])
                }
                state.feedbackObj = payload.feedbackObj;
                return
            }
        }
        state.msgList.push(payload);
        state.feedbackObj = payload.feedbackObj;
    },

    m_msg_loading_list(state, payload) {
        var list = state.msgList;
        var len = list.length;
        for (var i = len - 1; i >= 0; i--) {
            if (list[i].id === payload.id) {
                return
            }
        }
        state.msgList.push(payload);
    },

    m_update_type_img(state, payload) {
        var list = state.msgList;
        var len = list.length;
        for (var i = len - 1; i >= 0; i--) {
            if (list[i].msgid === payload.msgid) {
                var keys = Object.keys(payload)
                for (var o in payload) {
                    Vue.set(list[i], o, payload[o]);
                }
                return
            }
        }
        // 历史消息处理
        list = state.msgHistoryList;
        len = list.length;
        for (var i = len - 1; i >= 0; i--) {
            if (list[i].msgid === payload.msgid) {
                var keys = Object.keys(payload)
                for (var o in payload) {
                    Vue.set(list[i], o, payload[o]);
                }
                return
            }
        }
    },

    m_update_img(state, payload) {
        var list = state.msgList;
        var len = list.length;
        for (var i = len - 1; i >= 0; i--) {
            if (list[i].msgid === payload.msgid) {
                var content = list[i].content;
                Vue.set(list[i], 'content', content.replace(payload.oldLink, payload.link));
                return
            }
        }
        // 历史消息处理
        list = state.msgHistoryList;
        len = list.length;
        for (var i = len - 1; i >= 0; i--) {
            if (list[i].msgid === payload.msgid) {
                var content = list[i].content;
                Vue.set(list[i], 'content', content.replace(payload.oldLink, payload.link));
                return
            }
        }
    },

    m_update_file(state, payload) {
        var list = state.msgList;
        var len = list.length;
        for (var i = len - 1; i >= 0; i--) {
            if (list[i].msgid === payload.msgid) {
                var content = Object.assign({}, list[i].content, payload);
                Vue.set(list[i], 'content', content);
                return
            }
        }
        // 历史消息处理
        list = state.msgHistoryList;
        len = list.length;
        for (var i = len - 1; i >= 0; i--) {
            if (list[i].msgid === payload.msgid) {
                var content = Object.assign({}, list[i].content, payload);
                Vue.set(list[i], 'content', content);
                return
            }
        }
    },

    m_init_ok(state) {
        state.initStatus = true
    },

    m_calling(state, val) {
        state.calling = val;
    },

    m_remove_msg(state, id) {
        var list = state.msgList;
        var len = list.length;

        var tmp = [];
        var index = 0;

        for (var i = len - 1; i >= 0; i--) {
            if (list[i].id === id) {
                list.splice(i, 1);
                continue;
            }
        }
    },

    m_staffId(state, id) {
        state.staffId = id
    },

    m_update_callpeople(state, payload) {
        var list = state.msgList;
        var len = list.length;

        var tmp = [];
        var index = 0;

        for (var i = len - 1; i >= 0; i--) {
            if (list[i].id === payload.id) {
                payload.msgid = list[i].msgid;
                continue;
            }

            tmp.unshift(list[i])
        }
        tmp.push(payload)
        state.msgList = tmp
    },

    m_update_txt_tip(state, payload) {
        var list = state.msgList;
        var len = list.length;

        var tmp = [];
        var index = 0;

        for (var i = len - 1; i >= 0; i--) {
            if (list[i].id === payload.id) {
                if (list[i].content == payload.content) {
                    return;
                }
                payload.msgid = list[i].msgid;
                continue;
            }

            tmp.unshift(list[i])
        }
        tmp.push(payload)
        state.msgList = tmp
    },

    m_feedback_obj(state, obj) {
        state.feedbackObj = obj;
    },

    m_similar_obj(state, obj) {
        Vue.set(state.similarObj, 'key', obj.key)
        Vue.set(state.similarObj, 'list', obj.list)
    },

    m_blurry_questions(state, arr) {
        state.blurryQuestions = arr;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/sdkStore.js